<template>
  <div class="default-table customers-table">
    <customerView
      v-if="dialog.selected"
      :value="dialog.selected"
      :dialog="dialog.view"
      @edit="editDialog(dialog.selected)"
      @closed="onCloseView"
    />
    <customerSave
      v-if="dialog.selected"
      v-model="dialog.selected"
      :id="dialog.selected.id"
      :dialog="dialog.save"
      @closed="onCloseSave"
    />
    <DataTable
      name="customers"
      :items="data"
      :tablehdrs="tableheaders.customers"
      :customdata="true"
    >
      <template v-slot:default="{ item }">
        <tr
          :key="item.id"
          @dblclick="viewDialog(item)"
          class="table-row"
        >
          <td>
            <strong>{{ item.id }}</strong>
          </td>
          <td>
            {{ item.name }}
          </td>
          <td>
            {{ item.phone | phoneMask }}
          </td>
          <td>
            {{ item.identity | cpfMask }}
          </td>
          <td>
            <v-chip v-if="!item.addresses || item.addresses.length === 0" dark>{{ lang.customers.datatable.no_address }}</v-chip>
            <v-chip v-else v-for="(address, index) in item.addresses.slice().reverse().slice(0, 1)" :key="index" dark>{{ `${address.address} ${address.num} ${(address.comp !== undefined && address.comp ? '(' + address.comp + ')' : '' )} - ${address.neighborhood}` }}</v-chip>
          </td>
          <td class="actionsCol">
            <Actions :customer="item" @view="viewDialog(item)" @edit="editDialog(item)" />
          </td>
        </tr>
      </template>
      <template v-slot:mobile="{ item }">
        <tr
          :key="`mb-${item.id}`"
          @dblclick="viewDialog(item)"
          class="mobile_row table-row"
        >
          <td class="mobile_col">
            <ul class="flex-content pl-2">
              <li class="flex-item" :data-label="`${lang.customers.datatable.headers.id}:`">{{ item.id }}</li>
              <li class="flex-item" :data-label="`${lang.customers.datatable.headers.name}:`">{{ item.name }}</li>
              <li class="flex-item" :data-label="`${lang.customers.datatable.headers.phone}:`">{{ item.phone | phoneMask }}</li>
              <li class="flex-item" :data-label="`${lang.customers.datatable.headers.identity}:`">{{ item.identity | cpfMask }}</li>
              <li class="flex-item" :data-label="`${lang.customers.datatable.headers.address}:`">
                <v-chip v-if="!item.addresses || item.addresses.length === 0" dark>{{ lang.customers.datatable.no_address }}</v-chip>
                <v-chip v-else v-for="(address, index) in item.addresses.slice().reverse().slice(0, 1)" :key="index" dark>{{ `${address.address} ${address.num} ${(address.comp !== undefined && address.comp ? '(' + address.comp + ')' : '' )} - ${address.neighborhood}` }}</v-chip>
              </li>
              <li class="flex-item actions_row" :data-label="lang.customers.datatable.headers.action">
                <Actions :customer="item" @view="viewDialog(item)" @edit="editDialog(item)" />
              </li>
            </ul>
          </td>
        </tr>
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from '@/templates/global/DataTable'
import Actions from '@/components/customers/templates/Actions'
import customerView from '@/components/customers/View'
import customerSave from '@/components/customers/Save'

import defaults from '@/modules/default'
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import listDefaults from '@/mixins/defaults/list_subpage'

export default {
  components: { DataTable, Actions, customerView, customerSave },
  mixins: [ appdata, utils, listDefaults ],
  data: () => ({
    pageName: 'customers',
    default: { ...defaults.blank.customer }
  }),
  computed: {
    data: {
      get: function () {
        console.log('custom_data - customers', this.socketInfo.custom_data)
        if (this.socketInfo.custom_data && this.socketInfo.custom_data.customers) {
          return this.socketInfo.custom_data.customers
        }
        return []
      }
    }
  }
}
</script>

<style scoped src="@/components/customers/styles/list.scss" lang="scss"></style>
